export enum SocialLoginEnum {
  google,
  facebook,
  apple,
}
